define('uikit/helper/is.ignored.key',['require','exports','module'],function(require, exports, module) {
  // A list of event.key values that we don't want to trigger keyboard events
  // Used in input.counter.js and input.currency.js

  var IGNORED_KEYS = [
    'Tab',
    'Backspace',
    'Delete',
    'Enter',
    'Escape',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Left',
    'Right',
    'Up',
    'Down',
    'End',
    'Home',
    'PageDown',
    'PageUp',
    'Insert',
  ];

  var isIgnoredKey = function(key) {
    return IGNORED_KEYS.indexOf(key) !== -1;
  };

  module.exports = isIgnoredKey;
});

